<template>
    <div class='tep-button-wrap'>
        <dx-button hint="Справочник адресов" width='32px' height='32px' @click="openNsi">
            <img :src="'/infoenergo/assets/tep/tep-cards/phone.svg'" alt='' class='w-full h-full' >
        </dx-button>
    </div>
</template>

<script setup>
import { DxButton } from 'devextreme-vue';
import { dxUiNotify } from '@/utils/dx-helper';

const props = defineProps({
    meta: {
        type: Object,
        default: () => {}
    },
    serverData: {
        type: Object,
        default: () => {}
    }
});

const openNsi = () => {
    dxUiNotify('Функция в разработке', 'info', 3000);
    console.log('treeItemData', props.meta.treeItemData);
}
</script>

<style scoped>
.tep-button-wrap {
    display: flex;
    align-items: center;
    width: max-content;
    padding-top: 10px;
    padding-right: 4px;
}
</style>
